<template>
  <div class="content has-text-centered"></div>
</template>

<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import * as MutationTypes from 'src/store/mutation-types';
import q from 'q';
import QuRequest from '../../core/QuRequest';
import ewxLoginSDK from '@qtt/ewx-login-sdk';

const quRequest = new QuRequest();

const QU_LOCAL_PERMS = 'qu_local_perms';
const PERM_LOAING_TEXT = '登陆成功，正在获取权限中...';

export default {
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      menu: 'menuitems',
    }),
  },
  methods: {
    authentication() {
      return q.resolve(this.getPermUris(this.menu)).then(uris => {
        if (!uris.length) {
          return [];
        } else {
          return quRequest
            .send(quRequest.Apis.perm.member.checkPerm, {
              project_uri: uris.join(','),
              project: 'tagging',
            })
            .then(({ data: { perm } }) => {
              let perms = [];
              for (let key in perm) {
                let { has, name } = perm[key];
                let [project, uri] = key.split('::');
                perms.push({
                  uri,
                  has,
                  name,
                  project,
                });
              }
              return perms;
            });
        }
      });
    },
    getPermUris(menu, uris = []) {
      menu.forEach(menuItem => {
        let { meta = {} } = menuItem;
        let { auth = {} } = meta;
        if (auth.needApis) {
          auth.needApis.forEach(perm => {
            uris.push(`${perm.project}::${perm.path}`);
          });
        }
        if (menuItem.children) {
          this.getPermUris(menuItem.children, uris);
        }
      });
      return uris;
    },
    tokenLogin(token) {
      this.$store.commit(MutationTypes.SET_TOKEN, token);
      return this.sendAuthentication()
        .catch(err => {
          $message.error(`登陆失败：${err.message}`);
          throw err;
        })
        .done();
    },
    sendAuthentication() {
      this.$message.info(PERM_LOAING_TEXT);
      return this.authentication().then(perms => {
        if (perms) {
          localStorage.setItem(QU_LOCAL_PERMS, JSON.stringify(perms));
        }
        this.$router.push('/');
      });
    },
  },
  mounted() {
    const login = () => {
      const copyright = {};
      ewxLoginSDK.login({
        project: 'tagging',
        url: location.href,
        qa: !quRequest.isProduct(),
        copyright: JSON.stringify(copyright),
      });
    };
    ewxLoginSDK.getUserInfo({ isPerm: true }).then(
      res => {
        if (!res) {
          login();
        } else {
          const token = ewxLoginSDK.getToken({ isPerm: true });
          if (!token) {
            login();
          } else {
            this.$store.commit(MutationTypes.LOGIN_USER, {
              id: res.id,
              name: res.name,
            });
            this.tokenLogin(token);
          }
        }
      },
      rej => {
        login();
      },
    );
  },
};
</script>
<style lang="less">
.login-box {
  max-width: 400px;
  margin: 0 auto;
  box-shadow: 0 3px 4px rgba(0, 0, 0, 0.125);
  .ibox-content {
    min-height: 524px;
  }
  .qrcode-wrap,
  .password-wrap {
    margin-top: 20px;
  }
  .redirect-text {
    text-align: center;
    padding: 10px;
  }

  .el-tabs__nav {
    width: 100%;

    .el-tabs__item {
      width: 33.333%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// WxLogin.vue?70361edc